import React from 'react';
import { FaEye, FaIntercom, FaPaperclip, FaRadiationAlt } from 'react-icons/fa';
import CopyToClipboard from '../../../../../core/components/CopyToClipboard';
import { urlWebsite } from '../../../../../../../config';
import { useSocket } from '../../../../../../../hooks/Socket';
import { useModal } from '../../../../../../../hooks/Modal';
import Review from '../../../modules/Review';
import api from '../../../../../../../services/api';
import { useToast } from '../../../../../../../hooks/Toast';

interface ICreateModule {
  lineData: Record<string, any>;
}

export default function SendSingleToPosterModule({
  lineData,
}: ICreateModule): JSX.Element {

  const {addToast} = useToast();

  const { addModal,removeModal } = useModal();

  const sendToPoster = async () => {

  await  api.post(`/send-single-paper-to-poster/${lineData?._id?.toString()}`);

  addToast({title:'Enviado com sucesso', type:'success'});
  removeModal('modal')

  }

  const openReview = async (line) => {
 
    addModal({ key: 'modal',
      theme: 'whiteModalMedium', title: 'Enviar para a aba de pôsteres?', content: <>
      <button onClick={()=> sendToPoster()} className='greenButton2'>Sim</button>
        </>
    });
  }


  const moduleCreate = (): JSX.Element => {

    return <div title='Enviar para a aba de pôster' onClick={() => openReview(lineData)} style={{ cursor: 'pointer', width: '30px', height: '30px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '50%', border: '1px solid #333', margin: '5px' }}>
      <FaPaperclip className="hover" style={{ cursor: 'pointer' }} size={20} /></div>;
  }



  return moduleCreate();
}
